module.exports = __webpack_public_path__ + "media/images/logo-1aa53ead58d756ad4d1e4493a78b0df5.svg";